
function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}

const images = importAll(require.context('assets/icons/categories', false, /\.(png|jpe?g|svg)$/));


const mystyle = {
  width: 80,
};


var Categimages = [

  {
    src: images['Computer.png'],
    
    id: "Computer",
    style: mystyle,
    
    alt: "...",
  },


  {
    src: images['Printer.png'],
    id: "Printer",
    style:mystyle,
    
    alt: "...",
  },


  {
    src: images['iP-Phone.png'],
    id: "iP-Phone",
    style: mystyle,
    
    alt: "...",
  },



  {
    src: images['iP-Cam.png'],
    id: "iP-Cam",
    style: mystyle,
    
    alt: "...",
  },
  {
    src: images['Network.png'],
    id: "Network",
    style: mystyle,
    
    alt: "...",
  },


  {
    src: images['Office.png'],
    id: "Office",
    style: mystyle,
    
    alt: "...",
  },


  {
    src: images['Mail.png'],
    id: "Email",
    style: mystyle,
    
    alt: "...",
  },



  {
    src: images['App.png'],
    id: "Applications",
    style: mystyle,
    
    alt: "...",
  },







  {
    src: images['File.png'],
    id: "File",
    style: mystyle,
    
    alt: "...",
  },







];

var Sapicon =   {
  src: images['Sap.png'],
  id: "SAP",
  style: mystyle,
  
  alt: "...",
}
module.exports = { Categimages:Categimages, Sapicon:Sapicon };
